import { getDsLayoutComponentRenderer, getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import { FullPageMeetingRoom, MeetingRoomCardEmbed } from "@kaltura/mediaspace-shared-meeting-room";

export const render = getDsLayoutComponentRenderer(FullPageMeetingRoom);

export const renderEmbeddedCard = getStandaloneComponentRenderer(MeetingRoomCardEmbed);
